module.exports = __webpack_public_path__ + "img/image131.a7686d4b.png";